import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

export interface StatsBarChartDatum {
  label: string;
  value: number;
}

interface StatsBarChartProps {
  data: StatsBarChartDatum[];
  barColor?: string;
  height?: number;
  emptyText?: string;
  loading?: boolean;
}

const toFaNumber = (value: number) => value.toLocaleString("fa-IR");

export default function StatsBarChart({
  data,
  barColor = "#1dc399",
  height = 320,
  emptyText = "داده‌ای برای نمایش وجود ندارد",
  loading = false,
}: StatsBarChartProps) {
  if (loading) {
    return (
      <div
        className="flex w-full items-center justify-center rounded-xl bg-gray-50"
        style={{ height }}
      >
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primaryVar-200 border-t-primaryVar-500" />
      </div>
    );
  }

  if (!data.length) {
    return (
      <div
        className="flex w-full items-center justify-center rounded-xl bg-gray-50 text-sm text-gray-500"
        style={{ height }}
      >
        {emptyText}
      </div>
    );
  }

  const xInterval =
    data.length <= 14 ? 0 : Math.max(0, Math.ceil(data.length / 12) - 1);

  return (
    <div className="w-full" style={{ height }} dir="ltr">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 28 }}>
          <CartesianGrid strokeDasharray="4 4" vertical={false} stroke="#e5e7eb" />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: "#6b7280" }}
            tickLine={false}
            axisLine={{ stroke: "#e5e7eb" }}
            interval={xInterval}
            angle={-25}
            textAnchor="end"
            height={50}
            minTickGap={8}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fontSize: 12, fill: "#9ca3af" }}
            tickLine={false}
            axisLine={false}
            tickFormatter={toFaNumber}
            width={36}
          />
          <Tooltip
            cursor={{ fill: "rgba(29, 195, 153, 0.08)" }}
            contentStyle={{
              borderRadius: 12,
              border: "1px solid #e5e7eb",
              fontFamily: "IRANSansWeb, sans-serif",
              direction: "rtl",
            }}
            formatter={(value) => [
              toFaNumber(typeof value === "number" ? value : Number(value ?? 0)),
              "تعداد",
            ]}
            labelFormatter={(label) => String(label)}
          />
          <Bar
            dataKey="value"
            fill={barColor}
            radius={[6, 6, 0, 0]}
            maxBarSize={data.length > 40 ? 18 : 48}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
